import React, { useState, useEffect, useRef } from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Button,
  OutlinedInput,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Tooltip,
} from '@mui/material';
import axios from '../../../../utils/fvAxios';
import apiinfo from '../../../../utils/base-uri.json';
import { useForm } from 'react-hook-form';
import { getGlobalClientId, getToken,getOrgType } from "../../../../utils/Token";
import useFetch from "../../../../utils/useFetch";
import BaseURL from "../../../../utils/base-uri.json";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";


export default function ReportVendorTrainingName({ close, name }) {
  const [client, setClient] = React.useState([]);
  const [error, setError] = useState(null);
  const [token, setToken] = useState(getToken())
  const { register } = useForm();

  useEffect(() => {
    axios
      .get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=false&ClientIds=" +
        getGlobalClientId())
      .then((res) => {
        if (res.data.responseCode === 100) {
          setClient(res.data.data);
          if(getOrgType()=="Client"){
            setSelectValue1(res?.data?.data[0]?.value)}
        } else {
          setError(res.data.responseMessage);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };

  const [selectValue1, setSelectValue1] = useState('');
  const [fromDateValue, setFromDateValue] = useState(null);
  const [toDateValue, setToDateValue] = useState(null);
  const [toDateError, setToDateError] = useState('');
  const changeClients = (e) => {
    setSelectValue1(e);
  };

  const [location, setLocation] = React.useState([]);
  const { data: resps } = useFetch(
    'AdminVendors/GetClientTrainingTemplates?clientId=' + selectValue1
  );

  useEffect(() => {
    if (resps?.data) {
      setLocation(resps?.data);
    }
  }, [resps]);
  const formatDate = (date) => {
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(d.getDate()).padStart(2, '0');
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
  };
  

  const handleFromDateChange = (event) => {
    const formattedDate = formatDate(event); // Format the date
    setFromDateValue(formattedDate); // Store formatted date
    setToDateValue(''); // Reset ToDate

    setToDateError(""); // Clear error
  };
  
  const handleToDateChange = (event) => {
    const formattedToDate = formatDate(event); // Format the To Date
    const formattedFromDate = new Date(fromDateValue); // Convert FromDate for comparison
  
    if (formattedFromDate < new Date(event)) {
      setToDateValue(formattedToDate); // Set the formatted To Date
      setToDateError(""); // Clear error
    } else {
      setToDateValue('');
      setToDateError("To Date should be greater than From Date");
    }
  };
  

  const handleDateKeyDown = (e) => {
    e.preventDefault();// Prevent manual date input
  };
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);

  const handleEmployeeChange = (event) => {
    const { value, checked } = event.target;

    if (value === 'selectAll') {
      // Handle "Select All" checkbox
      setSelectAllChecked(checked);

      if (checked) {
        // If "Select All" is checked, select all employees
        const allEmployeeValues = location.map((item) => item.value);
        setSelectedEmployees(allEmployeeValues);
      } else {
        // If "Select All" is unchecked, clear the selection
        setSelectedEmployees([]);
      }
    } else {
      // Handle individual employee checkboxes
      const updatedSelected = checked
        ? [...selectedEmployees, value]
        : selectedEmployees.filter((val) => val !== value);

      setSelectedEmployees(updatedSelected);

      // Update "Select All" checkbox based on the selection
      setSelectAllChecked(
        updatedSelected.length === location.length && updatedSelected.length > 0
      );
    }
  };

  const menuListRef = useRef(null);
  const handleMenuOpen = () => {
    scrollToTopOfOtions();
  };
  const scrollToTopOfOtions = () => {
    setTimeout(() => {
      if (menuListRef.current) {
        const children = menuListRef.current.children;
        if (children.length >= 2) {
          const secondLastOption = children[children.length - 2];
          if (secondLastOption) {
            secondLastOption.scrollTop = 0;
          }
        }
      }
    }, 5);
  };
  return (
    <>
      <DialogTitle id="alert-dialog-title">{name}</DialogTitle>
      <DialogContent>
        <form
          action={
            BaseURL?.baseReportUrl + 'VendorEmployeeTrainingsByName.aspx'
          }
          method="post"
          target="_blank"
        >
          <div style={{ marginLeft: '25px' }}>
            <FormControl sx={{ m: 1, width: 320 }}>
              <span
                style={{
                  color: '#3E4A62',
                  fontSize: '14px',
                  fontWeight: '500',
                  marginTop: '5px',
                  marginBottom: '5px',
                }}
              >
                {' '}
                From{' '}
              </span>
              {/* <TextField
                type="date"
                sx={{ width: '320px' }}
                name="trainingfromDate"
                size="small"
                value={fromDateValue || ''}
                onChange={handleFromDateChange}
                onKeyDown={handleDateKeyDown}
              /> */}
                 <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={["year", "month", "day"]}
                  value={fromDateValue}
                  onChange={handleFromDateChange}
                  name="trainingfromDate"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px",
                      }}
                      size="small"
                      name="trainingfromDate"
                      onKeyDown={handleDateKeyDown}
                    />
                  )}
                />
              </LocalizationProvider>
              <span
                style={{
                  color: '#3E4A62',
                  fontSize: '14px',
                  fontWeight: '500',
                  marginTop: '5px',
                  marginBottom: '5px',
                }}
              >
                To
              </span>
              {/* <TextField
                type="date"
                sx={{ width: '320px' }}
                name="trainingtoDate"
                size="small"
                value={toDateValue || ''}
                onChange={handleToDateChange}
                onKeyDown={handleDateKeyDown}
              /> */}
                 <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={["year", "month", "day"]}
                  value={toDateValue}
                  name="trainingtoDate"
                  onChange={handleToDateChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px",
                      }}
                      name="trainingtoDate"
                      size="small"
                      onKeyDown={handleDateKeyDown}
                    />
                  )}
                />
              </LocalizationProvider>
              <span className='text-danger'>{toDateError}</span>
              <span
                style={{
                  color: '#3E4A62',
                  fontSize: '14px',
                  fontWeight: '500',
                  marginTop: '5px',
                  marginBottom: '5px',
                }}
              >
                Client
              </span>
              <Select
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                {...register('client')}
                sx={{
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 },
                  fontFamily: 'Arial, FontAwesome',
                }}
                name="clientOrgId"
                size="small"
                onChange={(e) => changeClients(e.target.value)}
                input={
                  <OutlinedInput
                    label="Select Client"

                    value={selectValue1}
                  />
                }
                MenuProps={MenuProps}
              >
                {client?.map((item, index) => (
                  <MenuItem key={index} title={item.text} value={item.value}>
                    {item.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl sx={{ marginLeft: 1, width: 320 }}>
              <span
                style={{
                  color: '#3E4A62',
                  fontSize: '14px',
                  fontWeight: '500',
                  marginTop: 4,
                  marginBottom: '5px',
                }}
              >
                Training Videos
              </span>
              <Select
                labelId="docs-label"
                id="docs-select"
                size="small"
                sx={{ width: '320px', overflow: 'hidden' }}
                name="ids"
                value={selectedEmployees}
                onChange={handleEmployeeChange}
                MenuProps={{
                  ref: menuListRef,
                  PaperProps: MenuProps.PaperProps,
                }
                }
                multiple
                renderValue={(selected) => {
                  scrollToTopOfOtions();
                  if (selected.length === 0) {
                    return 'Select Client';
                  }
                  if (selected.includes('selectAll')) {

                    return 'All Clients';
                  }
                  return selected
                    .map((value) =>
                      location.find((item) => item.value === value).text

                    )
                    .join(',');
                }}
              >
                <MenuItem value="selectAll" hidden={location?.length == 0}>
                  <Checkbox
                    id="select-all-checkbox"
                    checked={selectAllChecked}
                    onChange={handleEmployeeChange}
                    value="selectAll"
                  />
                  <label htmlFor="select-all-checkbox" style={{ fontSize: "16px", fontWeight: "500", color: "rgba(0, 0, 0, 0.87)", width: "320px", cursor: "pointer" }}>
                    Select All
                  </label>
                  {/* <ListItemText primary="Select All" /> */}
                </MenuItem>
                {location?.map((item, index) => (
                  <MenuItem key={item?.value} title={item.text} value={item?.value}>
                    <label htmlFor={`checkbox-${item?.value}`} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                      <Checkbox
                        id={`checkbox-${item?.value}`}
                        checked={selectedEmployees.includes(item?.value)}
                        onChange={handleEmployeeChange}
                        value={item?.value}
                      />
                      <ListItemText primary={item.text} />
                    </label>
                  </MenuItem>
                ))}


              </Select>


            </FormControl>
            <input type="text" name="baseids" hidden="true" value="" />
          </div>
          <DialogActions>
            <div className="login-help__buttonContainer">
              <Button
                variant="contained"
                className="login-help-button-cancel"
                onClick={close}
              >
                {' '}
                Cancel
              </Button>

              {fromDateValue === '' ||
                toDateValue === '' ||
                selectValue1 === '' ||
                selectedEmployees.length === 0 ? (
                <Tooltip title="All the fields are mandatory" followCursor>
                  <span>
                    <Button
                      variant="contained"
                      className="login-button-request"
                      onClick={close}
                      disabled={
                        fromDateValue === '' ||
                        toDateValue === '' ||
                        selectValue1 === '' ||
                        selectedEmployees.length === 0
                      }
                    >
                      Create Report
                    </Button>
                  </span>
                </Tooltip>
              ) : (
                <Button
                  variant="contained"
                  type="submit"
                  className="login-button-request"
                  onClick={close}
                >
                  Create Report
                </Button>
              )}
            </div>
          </DialogActions>
          <input type="hidden" name="token" value={token} />
        </form>

        <br />
      </DialogContent>
    </>
  );
}
